// extracted by mini-css-extract-plugin
export default {"columnContainer":"WhiteCard_columnContainer__Wd2D7","icon_image":"WhiteCard_icon_image__FBxpz","flex_card":"WhiteCard_flex_card__zAtyI","link":"WhiteCard_link__-CPHC"};